import React, { useEffect, useState } from 'react';
import { useSharedDataContext } from '../SharedDataContext';

const MedicalHistoryForm = ({ callFinalProposal }) => {
    const [ErrorMSG, setErrorMSG] = useState({});
    const [selectedVaccinations, setSelectedVaccinations] = useState([]);
    const [medicalDetails, setMedicalDetails] = useState({
        IsHealthy: "Y",
        PetIllnessDetails: "",
        Ped: "N",
        PreExistingDiseases: "",
        OwnAnotherDog: "N",
        LostAnyPet: "N",
    });

    const { sharedData, setSharedData } = useSharedDataContext();

    useEffect(() => {
        if (sharedData.medicalDetailsObj) {
            setMedicalDetails(sharedData.medicalDetailsObj);
            setSelectedVaccinations(sharedData.medicalDetailsObj?.selectedVaccinations); 
        }
    }, []);

    const handleVaccinationSelect = (vaccination) => {
        const updatedVaccinations = [...selectedVaccinations];

        // Check if the vaccination is already in the list
        const index = updatedVaccinations.indexOf(vaccination);
        if (index !== -1) {
            // If it's already selected, remove it
            updatedVaccinations.splice(index, 1);
        } else {
            // If it's not selected, add it
            updatedVaccinations.push(vaccination);
        }
        setSelectedVaccinations(updatedVaccinations); // Update selected vaccinations
    }

        const handleChange = (e) => {
            const { name, value } = e.target;
            setMedicalDetails({ ...medicalDetails, [name]: value });
        }

        const vaccinationNames = [
            "Rabies",
            "Distemper",
            "Hepatitis",
            "Adeno virus",
            "Leptospirosis",
            "Parainfluenza",
            "Parvovirus",
            "Coronavirus"
            // ... add other vaccination names here
        ];


        const submitMedicalForm = () => {
            const { IsHealthy, PetIllnessDetails, Ped, PreExistingDiseases, OwnAnotherDog, LostAnyPet } = medicalDetails;
            const ErrorMSG = {};
            let goto = true;
            if (!IsHealthy) {
                ErrorMSG["IsHealthy"] = "Please choose if the pet is healthy or not";
                goto = false;
            }
            if (IsHealthy == "N" && !PetIllnessDetails) {
                ErrorMSG["PetIllnessDetails"] = "Please enter the illness details";
                goto = false;
            }
            if (!Ped) {
                ErrorMSG["Ped"] = "Please choose if the pet has any pre existing disease or not";
                goto = false;
            }
            if (Ped == "Y" && !PreExistingDiseases) {
                ErrorMSG["PreExistingDiseases"] = "Please enter the pre existing diseases";
                goto = false;
            }
            if (selectedVaccinations.length == 0) {
                ErrorMSG["selectedVaccinations"] = "Please choose at least one of them";
                goto = false;
            }
          
            if (IsHealthy == "N" || (Ped == "Y" && PreExistingDiseases)) {
                alert("You Cannot Proceed Further as the Pet has Pre Existing Disease.");
                goto = false;
            }


            if (goto) {
                const medicalData = {
                    IsHealthy,
                    PetIllnessDetails,
                    Ped,
                    PreExistingDiseases,
                    selectedVaccinations,
                    OwnAnotherDog,
                    LostAnyPet
                }

                setSharedData(prev=>({ ...prev, medicalDetailsObj: medicalData }));
                callFinalProposal(medicalData);
            }
            else {
                setErrorMSG(ErrorMSG);
            }
        }


        return (<>
            <div className="HealthProUpdFormBoxSection">
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Is your pet dog sound and healthy?</label>
                    </div>
                    <div className="col-md-12">
                        <div className="form-check-inline">
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="IsHealthy" value="Y" checked={medicalDetails.IsHealthy === "Y"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>Yes
                            </label>
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="IsHealthy" value="N" checked={medicalDetails.IsHealthy === "N"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>No
                            </label>
                        </div>
                        <span className="Error">{ErrorMSG["IsHealthy"]}</span>
                    </div>
                    <div className='col-md-12'>
                        {medicalDetails.IsHealthy === "N" && (<div className="PetInput">
                            <input type="text" placeholder=" " id="ForUpPetIllnessDetails" className="InputBox" onChange={handleChange} name="PetIllnessDetails" value={medicalDetails.PetIllnessDetails} />
                            <label htmlFor="ForUpPetIllnessDetails">Pet Illness Details</label>
                            <span className="Error">{ErrorMSG["PetIllnessDetails"]}</span>
                        </div>)}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Any Pre-existing disease/conditions Pet Dog(s) suffers from?</label>
                    </div>
                    <div className="col-md-12">
                        <div className="form-check-inline">
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="Ped" value="Y" checked={medicalDetails.Ped === "Y"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>Yes
                            </label>
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="Ped" value="N" checked={medicalDetails.Ped === "N"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>No
                            </label>
                        </div>
                        <span className="Error">{ErrorMSG["Ped"]}</span>
                    </div>
                    <div className='col-md-12'>
                        {medicalDetails.Ped === "Y" && (<div className="PetInput">
                            <input type="text" placeholder=" " id="ForUpPreExistingDiseases" className="InputBox" onChange={handleChange} name="PreExistingDiseases" value={medicalDetails.PreExistingDiseases} />
                            <label htmlFor="ForUpPreExistingDiseases">Pre Existing Diseases</label>
                            <span className="Error">{ErrorMSG["PreExistingDiseases"]}</span>
                        </div>)}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Do you own any other dog apart from the one you are insuring?</label>
                    </div>
                    <div className="col-md-12">
                        <div className="form-check-inline">
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="OwnAnotherDog" value="Y" checked={medicalDetails.OwnAnotherDog === "Y"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>Yes
                            </label>
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="OwnAnotherDog" value="N" checked={medicalDetails.OwnAnotherDog === "N"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>No
                            </label>
                        </div>
                        <span className="Error">{ErrorMSG["OwnAnotherDog"]}</span>
                    </div>
                    <div className="col-md-12">
                        <label className="labeltext">Have you lost any pet dog(s) during the last three years?</label>
                    </div>
                    <div className="col-md-12">
                        <div className="form-check-inline">
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="LostAnyPet" value="Y" checked={medicalDetails.LostAnyPet === "Y"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>Yes
                            </label>
                            <label className="HLT_P_T_Box me-4 ms-0">
                                <input type="radio" name="LostAnyPet" value="N" checked={medicalDetails.LostAnyPet === "N"} onChange={handleChange} />
                                <span className="checkHLT_P_T_Box"></span>No
                            </label>
                        </div>
                        <span className="Error">{ErrorMSG["OwnAnotherDog"]}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <label className="labeltext">Which of the following vaccinations has been given to your Pet?</label>
                    </div>
                    <div className="col-md-12">
                        <div className="vaccinations">
                            <ul>
                                {vaccinationNames.map((vaccination) => (
                                    <li key={vaccination}>
                                        <label className="CompareCheck">
                                            <input
                                                className="checkCompare"
                                                type="checkbox"
                                                checked={selectedVaccinations?.includes(vaccination)}
                                                onChange={() => handleVaccinationSelect(vaccination)}
                                            />
                                            <span className="checkmarkCom"></span> <b>{vaccination}</b>
                                        </label>
                                    </li>
                                ))}
                            </ul>
                        <span className="Error">{ErrorMSG["selectedVaccinations"]}</span>
                        </div>
                    </div>
                </div>
                <div className="SameForm mt-4">
                    <div className="row">
                        <div className="col-md-12 text-center my-2">
                            <button type="submit" onClick={() => submitMedicalForm()} className="SMCBTN w-auto" >Review and do Payment <i className="fas fa-chevron-right"></i></button>
                    </div>
                </div>
                </div>
            </div>
    </>)
    }

    export default MedicalHistoryForm;